export function getLabelFromEnum<Enum extends Record<string, unknown>>(enumValue: Enum, currentValue: string) {
  return (
    Object.entries(enumValue)
      .find(([_, value]) => value === currentValue)?.[0]
      ?.replace(/([a-z])([A-Z])/g, '$1 $2') ?? ''
  );
}
